import React from "react";

const Input = ({ label, error, ...props }) => {
  return (
    <div className="mb-4">
      <label className="block text-white mb-2">{label}</label>
      <input
        className={`w-full p-3 rounded-md bg-[#334B70] text-white ${
          error ? "border-red-500" : "border-transparent"
        } focus:outline-none transition-colors`}
        {...props}
      />
      {error && <p className="mt-1 text-red-500 text-sm">{error}</p>}
    </div>
  );
};

export default Input;
